import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.318 4.75h-2.897v-.38C11.42 1.957 9.665 0 7.5 0S3.58 1.957 3.58 4.37v.38H.682c-.377 0-.682.34-.682.76v12.73c0 .42.305.76.682.76h13.636c.377 0 .682-.34.682-.76V5.51c0-.42-.305-.76-.682-.76m-9.204-.38c0-1.47 1.067-2.66 2.386-2.66S9.886 2.9 9.886 4.37v.38H5.114zm8.352 12.92H1.534V6.46H3.58v2.09c0 .104.076.19.17.19h1.193c.094 0 .17-.085.17-.19V6.46h4.773v2.09c0 .104.077.19.17.19h1.194c.094 0 .17-.085.17-.19V6.46h2.046z"
    }, null, -1)
  ])))
}
export default { render: render }